export default class ImageUploader {

    constructor() {
        this.form = $('.page-image-form');
        this.message = $('.message');
        this.pastedImage = $('.pasted-image');
        this.setEventListeners();
    }

    setEventListeners() {
        this.form.on('submit', e => this.uploadForm(e));
    }

    uploadForm(e) {
        e.preventDefault();
        let _this = this;
        let data = new FormData($('.page-image-form')[0]);

        $.ajax({
            url: '/admin/image-upload',
            method: 'POST',
            dataType: 'json',
            data: data,
            processData: false,
            contentType: false,
            success: function(data) {
                _this.showMessage(data);
            }
        });
    }

    // Updates Image on page
    updateImage(image){
        this.pastedImage.attr('src', image);
    }

    // Shows error/success message after upload
    showMessage(data) {
        let message = null, _this = this;

        if(data.success) {
            message = 'File Uploaded Successfully!';
            this.message.append("<p>" + message  + "</p>").addClass('show success');
        } else {
            message = data.error;
            this.message.append("<p>" + message  + "</p>").addClass('show error');
        }

        // Update Image on page
        this.updateImage(data.image);

        // Remove contents of message element and hide
        setTimeout(function() {
            _this.message.empty().removeClass('show').removeClass('error success');
        }, 5000);
    }




}


// WEBPACK FOOTER //
// ./public/js/ImageUploader.js